/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Teaserinformation1Inputs */

const en_common_teaserinformation1 = /** @type {(inputs: Common_Teaserinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaser Information`)
};

/**
* | output |
* | --- |
* | "Teaser Information" |
*
* @param {Common_Teaserinformation1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_teaserinformation1 = /** @type {((inputs?: Common_Teaserinformation1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Teaserinformation1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_teaserinformation1(inputs)
});
export { common_teaserinformation1 as "common_teaserInformation" }